import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { RequiredDocumentsAccordion } from '../../components/SupportingDocAccordions';

const Intro = () => (
  <p>
    We recommend uploading these documents before submitting this application so
    that you may be able to get a faster decision on your claim. You can upload
    them on the next page.
  </p>
);

const Documents = () => (
  <div>
    <h4 className="vads-u-color--gray-dark">Required documents</h4>
    <RequiredDocumentsAccordion />
  </div>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI("Veteran's DD214 and death certificate", Intro),
    'ui:description': Documents,
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
